<template>
  <div class="success" @click.stop>
    <div class="gift-container">
      <img
        class="gift"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/697d90892df15eb058296d442b438f47.png"
        alt=""
      />
      <img
        class="light"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2c95a0253728e754d20904afd2471334.png"
        alt=""
      />
    </div>
    <div class="top-content">
      <div class="title">签到成功！ 恭喜获得</div>
      <!-- 今日可得 -->
      <div class="today">
        <div class="sign-day">已连续签到{{ data.continuous_day }}天</div>
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in todayPrizeList"
            :key="index"
          >
            <img class="item-icon" :src="item.win_icon" alt="" />
            <div class="item-name">{{ item.win_goods_name }}</div>
            <div class="item-num">x{{ item.reward_num }}</div>
          </div>
        </div>
      </div>
      <!-- 明日可得 -->
      <div class="tomorrow" v-show="tomorrowPrizeList.length">
        <div class="t-title-c">
          <img
            class="t-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c12237dd37030e7787605393a357a2e3.webp"
            alt=""
          />
          <div class="t-title">明日不断签，可获得</div>
          <img
            class="t-icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c12237dd37030e7787605393a357a2e3.webp"
            alt=""
          />
        </div>
        <div class="prize-list">
          <div
            class="prize-item"
            v-for="(item, index) in tomorrowPrizeList"
            :key="index"
          >
            <img class="item-icon" :src="item.win_icon" alt="" />
            <div class="item-name">{{ item.win_goods_name }}</div>
            <div class="item-num">x{{ item.reward_num }}</div>
          </div>
        </div>
      </div>
      <div>
        <img
          class="line-left"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e077af93cfc9f2d849703d060a53661c.webp"
          alt=""
        />
        <img
          class="line-right"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e077af93cfc9f2d849703d060a53661c.webp"
          alt=""
        />
      </div>
    </div>
    <div class="bottom-content">
      <div v-if="tips">
        <div class="b-title">{{ tips.title }}</div>
        <div class="desc">{{ tips.desc }}</div>
      </div>
      <div class="btn" @click="bindToPrizePage">获取更多积分</div>
    </div>
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  computed: {
    todayPrizeList() {
      let index = this.data.continuous_day - 1
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    },
    tomorrowPrizeList() {
      let index = this.data.continuous_day
      return (
        (this.data.sign_task[index] && this.data.sign_task[index].goods_list) ||
        []
      )
    },
    tips() {
      let index = this.data.continuous_day - 1
      index = index < 0 ? 0 : index
      return this.tipsList[index]
    }
  },
  data() {
    return {
      tipsList: [
        {
          title: '记录体重，见证瘦身第一步',
          desc: '积分免费兑换体脂秤'
        },
        {
          title: '闭眼跟吃，3天瘦3斤',
          desc: ''
        },
        {
          title: '测一测，减脂体质对症下药',
          desc: ''
        },
        {
          title: '喝水提醒，喝够包瘦',
          desc: '积分优惠兑换吨吨桶'
        },
        {
          title: '三餐盲盒，吃对吃瘦',
          desc: '积分免费兑换低GI主食'
        },
        {
          title: '扫一扫，一起减脂不孤单',
          desc: ''
        },
        {
          title: '见证收获，对比你瘦了多少',
          desc: ''
        }
      ]
    }
  },
  methods: {
    bindToPrizePage() {
      this.$emit('close')
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.success {
  position: relative;
  width: 272px;
  box-sizing: border-box;
  text-align: center;

  .gift {
    z-index: 1;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translate(-50%, -77%);
    width: 188px;
    height: 140px;
    object-fit: contain;
  }

  .light {
    width: 100%;
    position: absolute;
    top: 0;
    transform: translate(0%, -78%);
    z-index: -1;
  }
  .top-content {
    position: relative;
    padding: 30px 10px 14px;
    margin-bottom: 8px;
    background: linear-gradient(
      60deg,
      #fe7a6b 0px,
      #fe5465 222px,
      #fe5465 100%
    );
    box-shadow: inset 0px 2px 12px 0px rgba(255, 255, 255, 0.5);
    border: 1px solid #fed88b;
    border-radius: 20px;
  }
  .bottom-content {
    background: linear-gradient(41deg, #fe7a6b 0%, #fe5465 100%);
    box-shadow: inset 0px 2px 12px 0px rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    border: 1px solid #fed88b;
    padding: 13px 22px 10px;
    .b-title {
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      line-height: 18px;
    }
    .desc {
      font-size: 13px;
      color: #ffffff;
      line-height: 18px;
    }
  }
  .title {
    margin-bottom: 17px;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 28px;
  }
  .line-left {
    width: 7px;
    position: absolute;
    bottom: 8px;
    left: 26px;
    transform: translate(0%, 100%);
  }

  .line-right {
    width: 7px;
    position: absolute;
    bottom: 8px;
    right: 26px;
    transform: translate(0%, 100%);
  }
  .today {
    position: relative;
    z-index: 1;
  }

  .tomorrow {
    .t-title-c {
      display: flex;
      align-items: center;
      justify-content: center;

      .t-icon {
        width: 9px;
        height: 11px;
        object-fit: contain;
      }

      .t-title {
        font-size: 11px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: rgba(139, 55, 22, 0.8);
        line-height: 12px;
        margin: 0 6px;
      }
    }
  }

  .today {
    padding: 10px;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0.9) 100%
    );
    box-shadow: 0px 0px 6px 0px rgba(254, 84, 101, 0.6);
    border-radius: 12px;
    backdrop-filter: blur(9px);
  }
  .tomorrow {
    position: relative;
    z-index: 2;
    padding: 10px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    opacity: 0.8;
    backdrop-filter: blur(9px);
  }
  .sign-day {
    position: absolute;
    left: 50%;
    top: 6px;
    transform: translate(-50%, -50%);
    width: 116px;
    height: 21px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b6196c149ceae99ccccf1b983bd6d3d1.webp');
    background-repeat: no-repeat;
    background-size: 100%;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: rgba(139, 55, 22, 0.8);
  }

  .prize-list {
    .prize-item {
      display: flex;
      align-items: center;
      padding: 8px 0px;
      border-bottom: 1px dashed rgba(139, 55, 22, 0.3);

      .item-icon {
        width: 26px;
        height: 26px;
        object-fit: contain;
        margin-right: 11px;
      }

      .item-name {
        text-align: left;
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        color: #8b3716;
        line-height: 24px;
        margin-right: 10px;
      }

      .item-num {
        font-size: 16px;
        font-family: PingFangSC, PingFang SC;
        color: #8b3716;
        line-height: 22px;
      }
    }

    .prize-item:last-child {
      border-bottom: none;
    }
  }

  .btn {
    position: relative;
    margin: 12px auto 0px;
    width: 228px;
    height: 40px;
    background: linear-gradient(360deg, #fecc3e 0%, #fed859 100%);
    box-shadow: 0px 3px 5px 0px #fe5465;
    border-radius: 20px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #8b3716;
    line-height: 40px;
  }

  .btn::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 11px;
    width: 208px;
    height: 32px;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 16px;
    opacity: 0.5;
  }

  .close {
    position: absolute;
    width: 24px;
    box-sizing: border-box;
    height: 24px;
    border: 1.5px solid #ffffff;
    border-radius: 12px;
    left: 50%;
    bottom: -20px;
    transform: translate(-50%, 100%);
    display: flex;
    align-items: center;
    justify-content: center;

    .iconfont {
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>
